export default "__VITE_ASSET__Dlu3fXac__"